export const trueFalseRenderer = (_instance, td, _row, _col, prop, value) => {
  if (value == null) {
    td.innerHTML = `<div class="truncated"></div>`;
    return td;
  }

  td.innerHTML = `<div class="truncated">${value === false ? "No" : "Yes"}</div>`;

  if ((prop == "pci_required" || prop == "cash_bonus_offered") && value) {
    td.style.backgroundColor = "#99cc00";
  }

  return td;
};
